export const schema = {
  properties: {
    id: {
      type: 'string',
      title: 'Id',
      hidden: true
    },
    registrationNumber: {
      type: 'string',
      title: 'Tax registration number',
      sortable: true
    },
    SubmissionGatewayName: {
      type: 'string',
      title: 'Gateway',
      sortable: true
    },
    actions: {
      type: 'object',
      title: 'Actions',
      properties: {
        deleteAction: {
          type: 'string',
          format: 'button',
          title: 'Delete',
          icon: 'delete_sign',
          color: 'danger'
        },
        editAction: {
          type: 'string',
          format: 'button',
          title: 'Edit',
          icon: 'edit',
          color: 'secondary'
        }
      }
    }
  }
}
